import { DateTool } from "./date-tool.js";
import router from "../../router";
import saveAs from "file-saver";
import store from "../../store";

class ReportPreviewTool {
  static previewReport(userName, reportURL, reportCreateTime) {
    const reportInfo = {
      userName,
      reportURL,
      reportCreateTime,
      showAIFloatingButton: true,
    };
    let routeData = router.resolve({
      path: "/report",
      query: reportInfo
    });
    window.open(routeData.href, "_blank");
  }

  static previewNewReport(userName, reportURL, reportCreateTime,deviceType) {
    // 保存到 sessionStorage 供新窗口使用
    sessionStorage.setItem('report_deviceType', deviceType);
    // 保存到当前窗口的 store
    store.commit('saveDeviceType', deviceType);
    
    const reportInfo = {
      userName,
      reportURL,
      reportCreateTime,
      showAIFloatingButton: true,
    };
    let routeData = router.resolve({
      path: "/m11b-report",
      query: reportInfo
    });
    window.open(routeData.href, "_blank");
  }

  static previewBloodOxygenReport(reportId, isNewReportConfig,token, uid,) {
    const reportInfo = {
      reportId,
      token,
      uid,
    };
    if(isNewReportConfig===1){
      let routeData = router.resolve({
        path: "/new-blood-oxygen-report",
        query: reportInfo
      });
      window.open(routeData.href, "_blank");
    }else{
      let routeData = router.resolve({
        path: "/blood-oxygen-report",
        query: reportInfo
      });
      window.open(routeData.href, "_blank");
    }
    
  }

  static previewLiangXiangReport(uid) {
    const reportInfo = {
      uid
    };
    let routeData = router.resolve({
      path: "/liangxiang-assessment-report",
      query: reportInfo
    });
    window.open(routeData.href, "_blank");
  }

  static downloadReport(userName, reportURL, reportCreateTime) {
    const reportDownloadURL = reportURL;
    const reportDownloadName =
      userName + DateTool.timestampToStr(reportCreateTime, "M月D日 h：m");
    // saveAs(reportDownloadURL, reportDownloadName); //八戒睡眠前缀网址直接用window.open会跳转PDF预览页面，需要用saveAs工具下载
    // window.open(reportDownloadURL)
    window.location.href = reportDownloadURL
  }

  static downloadBloodOxygenReport(reportURL) {
    window.open(reportURL); //阿里云前缀网址直接用window.open可以下载
  }

  static downloadImage(userName, createTimeStr, pngURL) {
    const reportDownloadName = `${userName} ${createTimeStr}.png`;
    // saveAs(pngURL, reportDownloadName);
    // window.open(pngURL)
    window.location.href = pngURL
  }

  static downloadImageData(userName, createTimeStr, imageData) {
    const reportDownloadName = `${userName} ${createTimeStr}.png`;
    let aLink = document.createElement("a");
    aLink.style.display = "none";
    aLink.href = imageData;
    aLink.download = reportDownloadName;
    document.body.appendChild(aLink);
    aLink.click();
    document.body.removeChild(aLink);
  }
}

export { ReportPreviewTool };
